import { render, staticRenderFns } from "./studentListFilter.vue?vue&type=template&id=51478904&scoped=true&"
import script from "./studentListFilter.vue?vue&type=script&lang=js&"
export * from "./studentListFilter.vue?vue&type=script&lang=js&"
import style0 from "./studentListFilter.vue?vue&type=style&index=0&id=51478904&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51478904",
  null
  
)

export default component.exports